import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {CalculationGoldFormUpsertRequest, CalculationGoldListElement} from './calculation-gold.models';
import {queryKey} from './calculation-gold-querykeys';

interface Props {
  selected: CalculationGoldListElement | null;
}
export function useCalculationGoldUpdateMutation(props: Props): UseMutationResult<CalculationGoldListElement> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (form: CalculationGoldFormUpsertRequest) =>
      AxiosHttpClient.put<CalculationGoldListElement>(
        `${environment.apiv4uri}calculation/gold/${props.selected.id}`,
        form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.list()});
    },
  });
}
